import { GET_PAGE_NAME, PageAction, SET_PAGE_NAME } from './types'

interface PageState {
  name: string
}

// page/reducer.ts
const initialState = {
  name: '',
}

// eslint-disable-next-line @typescript-eslint/default-param-last
const pageReducer = (state: PageState = initialState, action: PageAction) => {
  switch (action.type) {
    case GET_PAGE_NAME:
      return {
        ...state,
        name: action.payload,
      }
    case SET_PAGE_NAME:
      return {
        ...state,
        name: action.payload,
      }
    default:
      return state
  }
}

export default pageReducer
